<template>
<AppLayout>
  <div class="inventory">
    <section id="purchase-request-add">
      <div class="container">
        <!--<h5>Purchase Requisition</h5>-->
        <form @submit.prevent="savePurchaseRequest">
          <div class="form">
            <div class="row">
              <div class="fw-bold" style="opacity: 0.9 !important;">1. Request Information</div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Department <span class="text-danger">*</span></label>
                   <select
                    v-if="departments?.length > 0"
                    v-model="form.department"
                    class="form-control"
                    required
                    @change="onDepartmentChange"
                    disabled
                  >
                    <option value="">Select department</option>
                    <option v-for="d in departments" :key="d.id" :value="d.name" :data-id="d.id">{{ d.name }}</option>
                  </select>
                  <div v-else class="small text-muted">No departments available. Configure departments before submitting.</div>
                  <span v-if="errors.department" class="text-danger d-block">{{ errors.department }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Category <span class="text-danger">*</span></label>
                  <select v-model="form.procurementCategoryId" class="form-control" @change="errors.procurementCategoryId = ''">
                    <option value="">Select Category</option>
                    <option v-for="c in filteredProcurementCategories" :key="c.id" :value="c.id">{{ c.name }}</option>
                  </select>
                  <span v-if="errors.procurementCategoryId" class="text-danger">{{ errors.procurementCategoryId }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Project <span class="text-danger">*</span></label>
                  <div v-if="projects?.length > 0" class="searchable-select" style="position:relative">
                    <input
                      type="text"
                      class="full form-control"
                      id="projects"
                      required
                      placeholder="Search project..."
                      v-model="projectQuery"
                      @input="onProjectQuery"
                      @focus="showProjectList = true"
                      @blur="scheduleCloseProjectList"
                      @keydown.escape="showProjectList = false"
                      @keydown.enter.prevent="confirmProjectSelection"
                    />
                    <div v-if="showProjectList" class="search-results card" style="position:absolute; z-index:2000; width:100%; max-height:280px; overflow:auto;">
                      <div
                        v-for="proj in filteredProjects"
                        :key="proj.id"
                        class="search-item p-2"
                        @mousedown.prevent="selectProject(proj)"
                      >
                        {{ proj.name }}
                      </div>
                      <div v-if="filteredProjects.length === 0 && projectQuery.trim()" class="search-item p-2 text-muted">
                        No projects found
                      </div>
                    </div>
                  </div>
                  <div v-else class="small text-muted">No projects available. Configure projects before submitting.</div>
                  <span v-if="errors.project" class="text-danger d-block">{{ errors.project }}</span>
                </div>
              </div>
                <!--<div class="col-md-2">
                <div class="form-group">
                  <label>Vehicles (Optional)</label>
                  <multiselect
                    v-if="vehicles?.length > 0"
                    v-model="form.vehicleIds"
                    :options="vehicles"
                    :multiple="true"
                    track-by="id"
                    label="plateNumber"
                    placeholder="Select vehicles"
                    :custom-label="getVehicleLabel"
                  />
                  <div v-else class="small text-muted">No vehicles available to link.</div>
                </div>
              </div>
             Requested To removed -->
              <div class="col-md-2">
                <div class="form-group">
                  <label>Priority</label>
                  <select v-model="form.priority" class="form-control">
                    <option value="MEDIUM">Medium</option>
                    <option value="LOW">Low</option>
                    <option value="HIGH">High</option>
                    <option value="URGENT">Urgent</option>
                  </select>
                  <span v-if="errors.priority" class="text-danger">{{ errors.priority }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Expected Date</label>
                  <input type="date" v-model="form.expectedDate" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Purpose <span class="text-danger">*</span></label>
                  <input type="text" v-model="form.purpose" class="form-control" required />
                  <span v-if="errors.purpose" class="text-danger">{{ errors.purpose }}</span>
                </div>
              </div>
            </div>
            <div class="form">
          </div>
          </div>
          <div class="form">
            <div class="row mt-3">
              <div class="fw-bold" style="opacity: 0.9 !important;">2. Add Items</div>
              <div class="row align-items-end">
                <!-- Item type toggle -->
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Type</label>
                    <div class="btn-group btn-group-sm w-100" role="group">
                      <button type="button" class="btn" :class="newItem.type === 'product' ? 'type-toggle-active' : 'btn-style-2'" @click="setItemType('product')">Product</button>
                      <button type="button" class="btn" :class="newItem.type === 'service' ? 'type-toggle-active' : 'btn-style-2'" @click="setItemType('service')">Service</button>
                    </div>
                  </div>
                </div>

                <!-- Product / Service search with animation -->
                <transition name="item-type-fade" mode="out-in">
                <!-- Product search (shown when type=product) -->
                <div class="col-md-3" v-if="newItem.type === 'product'" key="product">
                  <div class="form-group">
                    <label>Product</label>
                    <div class="searchable-select" style="position:relative">
                      <input type="text" class="form-control" placeholder="Search product…" v-model="productQuery"
                        @input="onProductQuery" @focus="showProductList = true" @blur="scheduleCloseProductList"
                        @keydown.down.prevent="highlightNext" @keydown.up.prevent="highlightPrev"
                        @keydown.enter.prevent="confirmHighlighted" @keydown.escape="showProductList = false" />
                      <div v-if="showProductList" class="search-results card" style="position:absolute; z-index:2000; width:100%; max-height:280px; overflow:auto;">
                        <div v-for="(p, idx) in filteredProducts" :key="p.id" class="search-item p-2" :class="{ 'bg-light': idx === highlightedIndex }"
                          @mousedown.prevent="selectProduct(p)">
                          {{ p.name }}
                        </div>
                        <div v-if="filteredProducts.length === 0 && productQuery.trim()" class="search-item p-2 text-muted">
                          No products found
                        </div>
                        <div class="search-item p-2 add-new-row" :class="{ 'bg-light': highlightedIndex === filteredProducts.length }"
                          @mousedown.prevent="openCreateModal">
                          <span class="text-primary fw-semibold">+ Add new product{{ productQuery.trim() ? ` "${productQuery.trim()}"` : '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Service search (shown when type=service) -->
                <div class="col-md-3" v-else key="service">
                  <div class="form-group">
                    <label>Service</label>
                    <div class="searchable-select" style="position:relative">
                      <input type="text" class="form-control" placeholder="Search service…" v-model="serviceQuery"
                        @input="onServiceQuery" @focus="showServiceList = true" @blur="scheduleCloseServiceList"
                        @keydown.escape="showServiceList = false" @keydown.enter.prevent="confirmServiceSelection" />
                      <div v-if="showServiceList" class="search-results card" style="position:absolute; z-index:2000; width:100%; max-height:280px; overflow:auto;">
                        <div v-for="s in filteredServices" :key="s.id" class="search-item p-2"
                          @mousedown.prevent="selectService(s)">
                          {{ s.name }}<small v-if="s.code" class="text-muted"> ({{ s.code }})</small>
                        </div>
                        <div v-if="filteredServices.length === 0 && serviceQuery.trim()" class="search-item p-2 text-muted">
                          No services found
                        </div>
                        <div class="search-item p-2 add-new-row" @mousedown.prevent="openCreateServiceModal">
                          <span class="text-primary fw-semibold">+ Add new service{{ serviceQuery.trim() ? ` "${serviceQuery.trim()}"` : '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </transition>

                <div class="col-md-2">
                  <div class="form-group">
                    <label>Product Description</label>
                    <input type="text" placeholder="color, size, spec etc" v-model="newItem.productDescription" class="form-control" />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label>Unit</label>
                    <input type="text" v-model="newItem.unit" class="form-control" readonly />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Quantity</label>
                    <input type="number" min="1" v-model.number="newItem.quantity" class="form-control" @input="sanitizeQuantity" />
                   
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label>Request Description</label>
                    <input type="text" v-model="newItem.notes" class="form-control" />
                  </div>
                </div>
                
                <div class="col-md-2" >
                  <div class="form-group pt-8" >
                    <label>Link to vehicle?</label>
                      <div class="components-button">
                        <span class="switcher switcher-1">
                          <input
                            type="checkbox"
                            id="vehicle-switcher"
                            v-model="showVehicleSelector"
                            @change="!showVehicleSelector && (newItem.vehicleIds = [])"
                          />
                          <label for="vehicle-switcher"></label>
                        </span>
                      </div>
                      
                  </div>
                </div>

                <div class="col-md-2" v-if="showVehicleSelector">
                  <div class="form-group" v-if="showVehicleSelector">
                    <label>Select Vehicles</label>
                    <multiselect
                      v-if="vehicles?.length > 0"
                      v-model="newItem.vehicleIds"
                      :options="vehicles"
                      :multiple="true"
                      track-by="id"
                      label="plateNumber"
                      placeholder="Select vehicles"
                      :custom-label="getVehicleLabel"
                    />
                    <div v-else class="small text-muted">No vehicles available to link.</div>
                  </div>
                </div>
                
                <div class="col-md-2">
                  <div class="form-group">
                    <button type="button" class="btn btn-small btn-style-2 purchase-request-action-btn" @click="addItem">Add</button>
                  </div>
                </div>
              </div>
              <table v-if="form.items.length > 0" class="table table-hover mt-3">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Type</th>
                    <th>Item</th>
                    <th>Unit</th>
                    <th>Qty</th>
                    <th>Notes</th>
                    <th v-if="hasAnyVehicles">Vehicles</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="form.items.length > 0">
                  <tr v-for="(item, idx) in filteredItems" :key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td><span class="badge" :class="item.type === 'service' ? 'badge-info' : 'badge-secondary'" style="font-size:11px;">{{ item.type || 'product' }}</span></td>
                    <td>
                      <span v-if="item.type === 'service'">{{ services.find(s => s.id === item.serviceId)?.name || item.serviceName || '' }}</span>
                      <span v-else>{{ item.productId ? (products.find(p => p.id === item.productId)?.name || '') : '' }}</span>
                    </td>
                    <td>{{ getItemUnit(item) }}</td>
                    <td>{{ item.quantity || '' }}</td>
                    <td>{{ item.notes || '-' }}</td>
                    <td v-if="hasAnyVehicles">
                      <span v-if="item.vehicleIds && item.vehicleIds.length > 0">
                        <span v-for="vid in item.vehicleIds" :key="vid" class="badge bg-light text-dark me-1">{{ getVehicleLabel(vehicles.find(v => v.id === vid)) }}</span>
                      </span>
                      <span v-else class="text-muted">—</span>
                    </td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm" @click="removeItem(idx)">Remove</button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr><td colspan="7" class="text-center">No items added</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="form mt-3">
            <div class="row">
              <div class="fw-bold" style="opacity: 0.9 !important;">3. Attachments (optional)</div>
              <div class="col-md-12">
                <div class="form-group">
                  <input
                    type="file"
                    ref="attachmentsInput"
                    class="form-control"
                    multiple
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.csv,.zip,.txt"
                    @change="onAttachmentsChange"
                  />
                  <small class="text-muted">PDF, Word, Excel, images, CSV, ZIP, TXT. Max 10 files, 10MB each.</small>
                </div>
                <div v-if="form.attachments.length > 0" class="mt-2">
                  <div class="d-flex flex-wrap gap-2 align-items-center">
                    <span
                      v-for="(f, idx) in form.attachments"
                      :key="idx"
                      class="badge bg-secondary d-inline-flex align-items-center gap-1 attachment-chip"
                    >
                      <span class="attachment-name">{{ f.name || f.file?.name }}</span>
                      <button
                        type="button"
                        class="attachment-remove"
                        aria-label="Remove file"
                        title="Remove"
                        @click.stop="removeAttachment(idx)"
                      >×</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
          <div  class="form-actions d-flex justify-content-end mt-5 mb-5">
            <button type="submit" class="btn btn-small btn-style-2 purchase-request-action-btn" :disabled="saving || form.items.length === 0">
              <span v-if="saving" class="d-inline-flex align-items-center gap-1">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Submitting...
              </span>
              <template v-else>Submit Request</template>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>

  <!-- ── Quick Create Service Modal ── -->
  <teleport to="body">
    <div v-if="showCreateServiceModal" class="qcp-overlay" @mousedown.self="closeCreateServiceModal">
      <div class="qcp-box">
        <div class="qcp-header">
          <h6 class="mb-0 fw-bold">Create New Service</h6>
          <button type="button" class="btn-close" @click="closeCreateServiceModal"></button>
        </div>
        <div class="qcp-body">
          <div class="form-group mb-3">
            <label class="form-label">Service Name <span class="text-danger">*</span></label>
            <input type="text" v-model="newService.name" class="form-control" placeholder="e.g. System Integration" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Code (optional)</label>
            <input type="text" v-model="newService.code" class="form-control" placeholder="e.g. SVC-001" />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Category</label>
            <select v-model="newService.categoryId" class="form-control">
              <option :value="null">— None —</option>
              <option v-for="c in serviceCategories" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Unit</label>
            <select v-model="newService.unitId" class="form-control">
              <option :value="null">— None —</option>
              <option v-for="u in serviceUnits" :key="u.id" :value="u.id">{{ u.name }}{{ u.symbol ? ` (${u.symbol})` : '' }}</option>
            </select>
          </div>
          <div class="form-group mb-1">
            <label class="form-label">Unit Price</label>
            <input type="number" v-model="newService.unitPrice" class="form-control" placeholder="0.00" min="0" step="0.01" />
          </div>
        </div>
        <div class="qcp-footer">
          <button type="button" class="btn btn-secondary btn-sm" @click="closeCreateServiceModal">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" @click="createNewService" :disabled="savingNewService">
            <span v-if="savingNewService"><span class="spinner-border spinner-border-sm me-1"></span>Creating…</span>
            <span v-else>Create Service</span>
          </button>
        </div>
      </div>
    </div>
  </teleport>

  <!-- ── Quick Create Product Modal ── -->
  <teleport to="body">
    <div v-if="showCreateModal" class="qcp-overlay" @mousedown.self="closeCreateModal">
      <div class="qcp-box">
        <div class="qcp-header">
          <h6 class="mb-0 fw-bold">Create New Product</h6>
          <button type="button" class="btn-close" @click="closeCreateModal"></button>
        </div>
        <div class="qcp-body">
          <div class="form-group mb-3">
            <label class="form-label">Product Name <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="newProduct.name"
              class="form-control"
              placeholder="Enter product name"
              ref="newProductNameInput"
            />
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Category <span class="text-danger">*</span></label>
            <select v-model="newProduct.categoryId" class="form-control" @change="newProduct.subcategoryId = null">
              <option value="">-- Select category --</option>
              <option v-for="c in productCategories" :key="c.id" :value="c.id">{{ c.category }}</option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Subcategory</label>
            <select v-model="newProduct.subcategoryId" class="form-control">
              <option :value="null">-- Select subcategory --</option>
              <option v-for="sc in filteredSubcategories" :key="sc.id" :value="sc.id">{{ getSubcategoryLabel(sc) }}</option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-label">Unit <span class="text-danger">*</span></label>
            <select v-model="newProduct.unitId" class="form-control" @change="newProduct.subunitId = null">
              <option value="">-- Select unit --</option>
              <option v-for="u in productUnits" :key="u.id" :value="u.id">{{ u.unit }}</option>
            </select>
          </div>
          <div class="form-group mb-1">
            <label class="form-label">Sub Unit</label>
            <select v-model="newProduct.subunitId" class="form-control">
              <option :value="null">-- Select sub unit --</option>
              <option v-for="su in filteredSubUnits" :key="su.id" :value="su.id">{{ su.subUnit || su.name || su.unit }}</option>
            </select>
          </div>
        </div>
        <div class="qcp-footer">
          <button type="button" class="btn btn-secondary btn-sm" @click="closeCreateModal">Cancel</button>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="createNewProduct"
            :disabled="savingNewProduct"
          >
            <span v-if="savingNewProduct">
              <span class="spinner-border spinner-border-sm me-1"></span>Creating…
            </span>
            <span v-else>Create Product</span>
          </button>
        </div>
      </div>
    </div>
  </teleport>
</AppLayout>
</template>
<script>

import AppLayout from '@/components/AppLayout.vue'
import { toast } from 'vue3-toastify';
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect';

const BASE_URL = process.env.VUE_APP_URL;

export default {
  name: 'PurchaseRequestForm',
  components: { AppLayout, Multiselect },

  data() {
    return {
      form: {
        department: '',
        departmentId: null,
        project: '',
        vehicleIds: [],
        procurementCategoryId: '',
        priority: 'MEDIUM',
        expectedDate: '',
        purpose: '',
        description: '',
        items: [],
        attachments: []
      },
      newItem: {
        type: 'product',
        productId: '',
        serviceId: '',
        serviceName: '',
        unit: '',
        quantity: 1,
        notes: '',
        productDescription: '',
        vehicleIds: [],
      },
      products: [],
      vehicles: [],
      projectQuery: '',
      productQuery: '',
      showProductList: false,
      showProjectList: false,
      highlightedIndex: -1,
      // Services
      services: [],
      serviceQuery: '',
      showServiceList: false,
      serviceCategories: [],
      serviceUnits: [],
      categories: [],
      departmentCategories: {},  // cache: departmentId -> category array
      loadingDeptCategories: false,
      errors: {},
      saving: false,
      isEdit: false,
      requestId: null,
      // Quick-create product modal
      showCreateModal: false,
      newProduct: { name: '', categoryId: '', unitId: '', subcategoryId: null, subunitId: null },
      savingNewProduct: false,
      // Quick-create service modal
      showCreateServiceModal: false,
      newService: { name: '', code: '', categoryId: null, unitId: null, unitPrice: '' },
      savingNewService: false,
      closeProjectListTimer: null,
      closeProductListTimer: null,
      closeServiceListTimer: null,
      showVehicleSelector: false,
    }
  },
  computed: {
    ...mapGetters(["getProjects", "getDepartments", "getCategories", "getUnits", "getSubUnits", "getSubCategories"]),
    filteredItems() {
      return this.form.items.filter(i => i !== undefined && i !== null);
    },
    selectedProduct() {
      return this.products.find(p => p.id === this.newItem.productId) || null;
    },
    filteredProducts() {
      const q = (this.productQuery || '').toLowerCase().trim()
      if (!q) return this.products.slice(0, 200)
      return this.products.filter(p => (p.name || '').toLowerCase().includes(q)).slice(0, 200)
    },
    filteredProjects() {
      const q = (this.projectQuery || '').toLowerCase().trim()
      if (!q) return this.projects.slice(0, 200)
      return this.projects.filter(p => (p.name || '').toLowerCase().includes(q)).slice(0, 200)
    },
    filteredServices() {
      const q = (this.serviceQuery || '').toLowerCase().trim()
      if (!q) return this.services.slice(0, 200)
      return this.services.filter(s =>
        (s.name || '').toLowerCase().includes(q) || (s.code || '').toLowerCase().includes(q)
      ).slice(0, 200)
    },
    projects() { return this.getProjects || [] },
    departments() { return this.getDepartments || [] },
    productCategories() { return this.getCategories || [] },
    productUnits() { return this.getUnits || [] },
    subUnits() { return this.getSubUnits || [] },
    subcategories() { return this.getSubCategories || [] },
    filteredSubUnits() {
      const unitId = this.newProduct?.unitId ? Number(this.newProduct.unitId) : null
      if (!unitId) return this.subUnits || []
      return (this.subUnits || []).filter(su => {
        if (!su) return false
        if (su.unitId && Number(su.unitId) === unitId) return true
        if (su.unit && typeof su.unit === 'object' && su.unit.id && Number(su.unit.id) === unitId) return true
        if (su.subunit && typeof su.subunit === 'object' && su.subunit.id && Number(su.subunit.id) === unitId) return true
        return false
      })
    },
    filteredSubcategories() {
      const categoryId = this.newProduct?.categoryId ? Number(this.newProduct.categoryId) : null
      if (!categoryId) return this.subcategories || []
      return (this.subcategories || []).filter(sc => {
        if (!sc) return false
        if (sc.categoryId && Number(sc.categoryId) === categoryId) return true
        if (sc.category && typeof sc.category === 'object' && sc.category.id && Number(sc.category.id) === categoryId) return true
        if (sc.subcategory && typeof sc.subcategory === 'object' && sc.subcategory.id && Number(sc.subcategory.id) === categoryId) return true
        return false
      })
    },


    hasAnyVehicles() {
      return this.form.items.some(i => Array.isArray(i.vehicleIds) && i.vehicleIds.length > 0)
    },
    filteredProcurementCategories() {
      const deptId = this.form.departmentId
      if (!deptId) return this.categories
      
      const deptCats = this.departmentCategories[deptId]
      // If no assignments configured, fall back to all categories
      if (!deptCats || deptCats.length === 0) return this.categories
      
      // Get IDs of department-specific categories
      const deptCatIds = new Set(deptCats.map(dc => dc.id))
      
      // Include:
      // 1. Categories specifically assigned to this department
      // 2. Categories with no department assignments (available to ALL departments)
      return this.categories.filter(c => {
        // Category is assigned to this department
        if (deptCatIds.has(c.id)) return true
        // Category has no department assignments (available to all)
        if (!c.departmentAssignments || c.departmentAssignments.length === 0) return true
        return false
      })
    },
  },

  mounted() {
    this.fetchDepartments()
    this.fetchProjects()
    this.fetchCategories()
    this.fetchUnits()
    this.fetchSubUnits()
    this.fetchSubCategories()
    this.loadProducts()
    this.loadVehicles()
    this.loadServices()
    this.loadServiceCategories()
    this.loadServiceUnits()
    this.loadCategories()

    if (this.$route.params.id) {
      this.isEdit = true
      this.requestId = this.$route.params.id
      this.loadPurchaseRequest()
    } else {
      // Auto-select department for new request
      this.autoSelectUserDepartment()
    }
  },

  methods: {

    ...mapActions(["fetchProjects", "fetchDepartments", "fetchCategories", "fetchUnits", "fetchSubUnits", "fetchSubCategories"]),

    autoSelectUserDepartment() {
      try {
        const permissionStr = localStorage.getItem('permission')
        if (!permissionStr) {
          console.warn('[AddPurchaseRequest] No permission found in localStorage')
          return
        }
        const permission = JSON.parse(permissionStr)
        console.log('[AddPurchaseRequest] User Permission:', permission)

        // Try to get department name or ID from permission
        const userDeptName = permission?.deparment?.name || permission?.department?.name
        const userDeptId = permission?.departmentId || permission?.deparmentId

        const applySelection = () => {
          if (!this.departments || this.departments.length === 0) return false

          let targetDept = null
          if (userDeptId) {
            targetDept = this.departments.find(d => Number(d.id) === Number(userDeptId))
          }
          if (!targetDept && userDeptName) {
            targetDept = this.departments.find(d => d.name === userDeptName)
          }

          if (targetDept) {
            console.log('[AddPurchaseRequest] Auto-selecting department:', targetDept.name)
            this.form.department = targetDept.name
            this.onDepartmentChange()
            return true
          }
          return false
        }

        // Try applying immediately
        if (applySelection()) return

        // If not successful (maybe departments not loaded), setup watch
        const unwatch = this.$watch('departments', (newDepts) => {
          if (newDepts && newDepts.length > 0) {
            if (applySelection()) {
              unwatch()
            }
          }
        }, { immediate: true })

      } catch (e) {
        console.error('[AddPurchaseRequest] Error auto-selecting department:', e)
      }
    },

    onDepartmentChange() {
      this.errors.department = ''
      // Resolve departmentId from the selected department name
      const selectedName = this.form.department
      const dept = this.departments.find(d => d.name === selectedName)
      this.form.departmentId = dept ? dept.id : null
      // Reset category selection when department changes
      this.form.procurementCategoryId = ''
      // Load categories for this department if not cached
      if (this.form.departmentId && !this.departmentCategories[this.form.departmentId]) {
        this.loadDepartmentCategories(this.form.departmentId)
      }
    },

    async loadDepartmentCategories(departmentId) {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${BASE_URL}/tender-category/by-department/${departmentId}`, {
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        })
        const data = await res.json()
        const cats = Array.isArray(data.data) ? data.data : (Array.isArray(data) ? data : [])
        this.departmentCategories = { ...this.departmentCategories, [departmentId]: cats }
      } catch {
        // On error keep empty — will fall back to all categories
        this.departmentCategories = { ...this.departmentCategories, [departmentId]: [] }
      }
    },

    async loadProducts() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const res = await fetch(`${BASE_URL}/products`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        this.products = await res.json();
      } catch {
        console.log('Failed to load products');
      }
    },

    async loadServices() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${BASE_URL}/services`, {
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        })
        const data = await res.json()
        this.services = Array.isArray(data.data) ? data.data : []
      } catch {
        console.log('Failed to load services')
      }
    },

    async loadVehicles() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${BASE_URL}/vehicles?page=1&limit=200`, {
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        })
        const data = await res.json()
        this.vehicles = Array.isArray(data.data) ? data.data : (Array.isArray(data?.items) ? data.items : [])
      } catch {
        this.vehicles = []
        console.log('Failed to load vehicles')
      }
    },

    getVehicleLabel(v) {
      if (!v) return ''
      const details = [v.make, v.model].filter(Boolean).join(' ')
      return details ? `${v.plateNumber} — ${details}` : (v.plateNumber || `Vehicle #${v.id}`)
    },
    async loadServiceCategories() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${BASE_URL}/service-categories`, {
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        })
        const data = await res.json()
        this.serviceCategories = Array.isArray(data.data) ? data.data : []
      } catch {
        this.serviceCategories = []
      }
    },
    async loadServiceUnits() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${BASE_URL}/service-units`, {
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        })
        const data = await res.json()
        this.serviceUnits = Array.isArray(data.data) ? data.data : []
      } catch {
        this.serviceUnits = []
      }
    },

    setItemType(type) {
      this.newItem.type = type
      this.newItem.productId = ''
      this.newItem.serviceId = ''
      this.newItem.serviceName = ''
      this.newItem.unit = ''
      this.productQuery = ''
      this.serviceQuery = ''
      this.showProductList = false
      this.showServiceList = false
    },

    onServiceQuery() {
      this.showServiceList = true
    },

    scheduleCloseProductList() {
      this.closeProductListTimer = setTimeout(() => { this.showProductList = false }, 150)
    },

    scheduleCloseServiceList() {
      this.closeServiceListTimer = setTimeout(() => { this.showServiceList = false }, 150)
    },

    selectService(s) {
      this.newItem.serviceId = s.id
      this.newItem.serviceName = s.name
      this.newItem.unit = this.getServiceUnitLabel(s) || ''
      this.serviceQuery = s.name
      this.showServiceList = false
    },

    confirmServiceSelection() {
      if (this.filteredServices.length > 0) {
        this.selectService(this.filteredServices[0])
      } else if (this.serviceQuery.trim()) {
        this.openCreateServiceModal()
      }
    },

    openCreateServiceModal() {
      if (this.closeServiceListTimer) clearTimeout(this.closeServiceListTimer)
      this.newService = { name: this.serviceQuery.trim(), code: '', categoryId: null, unitId: null, unitPrice: '' }
      this.showCreateServiceModal = true
      this.showServiceList = false
    },

    closeCreateServiceModal() {
      this.showCreateServiceModal = false
      this.newService = { name: '', code: '', categoryId: null, unitId: null, unitPrice: '' }
    },

    async createNewService() {
      if (!this.newService.name.trim()) { toast.error('Service name is required'); return }
      this.savingNewService = true
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch(`${BASE_URL}/services`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
          body: JSON.stringify({
            name: this.newService.name.trim(),
            code: this.newService.code?.trim() || undefined,
            categoryId: this.newService.categoryId || undefined,
            unitId: this.newService.unitId || undefined,
            unitPrice: this.newService.unitPrice !== '' ? Number(this.newService.unitPrice) : undefined,
          })
        })
        const data = await res.json()
        const created = data.data || data
        if (res.ok && created?.id) {
          this.services.push(created)
          this.selectService(created)
          this.addItem()
          this.closeCreateServiceModal()
          toast.success('Service created and added to list')
        } else {
          toast.error(data.message || 'Failed to create service')
        }
      } catch {
        toast.error('Failed to create service')
      } finally {
        this.savingNewService = false
      }
    },

    async loadCategories() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const res = await fetch(`${BASE_URL}/tender-category`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        const result = await res.json();
        this.categories = Array.isArray(result.data) ? result.data : result;
      } catch {
        console.log('Failed to load Procurement Categories');
      }
    },

    async loadPurchaseRequest() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const res = await fetch(`${BASE_URL}/purchase-requests/${this.requestId}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        const resp = await res.json();
        const r = resp.data || resp;

        const status = (r.status || '').toString().toUpperCase();
        if (status !== 'PENDING') {
          toast.error('Only pending purchase requests can be edited');
          this.$router.push('/transaction/purchase-request');
          return;
        }

        this.form = {
          department: r.department || r.department || '',
          departmentId: null,
          project: r.project || r.project || '',
          vehicleId: r.vehicleId || r.vehicle?.id || '',
          procurementCategoryId: r.procurementCategoryId || r.categoryId,
          priority: r.priority || r.urgency || 'MEDIUM',
          expectedDate: r.expectedDate?.split('T')[0] || r.expectedDeliveryDate?.split('T')[0] || '',
          purpose: r.purpose || r.justification || '',
          description: r.description || '',
          items: (r.items || []).map(i => ({
            id: i.id,
            productId: i.productId,
            serviceId: i.serviceId,
            type: i.serviceId ? 'service' : 'product',
            quantity: i.quantity,
            unit: i.product?.unit ? (i.product.unit.unit || i.product.unit.symbol || i.product.unit.name || '') : (i.service?.unit ? (i.service.unit.name || i.service.unit.symbol || '') : ''),
            notes: i.notes || ''
          })),
          attachments: []
        };
        this.projectQuery = this.form.project || ''
        // Resolve departmentId for category filtering
        const dept = this.departments.find(d => d.name === this.form.department)
        this.form.departmentId = dept ? dept.id : null
        if (this.form.departmentId) this.loadDepartmentCategories(this.form.departmentId)
      } catch {
        console.log('Failed to load purchase request');
        this.$router.push('/transaction/purchase-request');
      }
    },

    addItem() {
      if (this.newItem.type === 'service') {
        if (!this.newItem.serviceId) { toast.error('Select a service'); return; }
      } else {
        if (!this.newItem.productId) { toast.error('Select a product'); return; }
      }
      if (!this.newItem.quantity || this.newItem.quantity < 1) {
        toast.error('Enter a valid quantity'); return;
      }
      this.form.items.push({
        type: this.newItem.type || 'product',
        productId: this.newItem.type === 'service' ? undefined : this.newItem.productId,
        serviceId: this.newItem.type === 'service' ? this.newItem.serviceId : undefined,
        serviceName: this.newItem.type === 'service' ? this.newItem.serviceName : undefined,
        unit: this.newItem.unit,
        quantity: this.newItem.quantity,
        notes: this.newItem.notes,
        productDescription: this.newItem.productDescription,
        vehicleIds: Array.isArray(this.newItem.vehicleIds) ? this.newItem.vehicleIds.map(v => (typeof v === 'object' && v !== null ? v.id : v)) : [],
      });
      this.newItem = { type: this.newItem.type, productId: '', serviceId: '', serviceName: '', unit: '', quantity: 1, notes: '', productDescription: '', vehicleIds: [] };
      this.showVehicleSelector = false;
      this.productQuery = '';
      this.serviceQuery = '';
    },

    removeItem(index) {
      this.form.items.splice(index, 1)
    },

    sanitizeQuantity() {
      const q = this.newItem.quantity
      if (q == null || q === '' || Number(q) < 1 || isNaN(Number(q))) {
        this.$nextTick(() => { this.newItem.quantity = 1 })
      }
    },

    onAttachmentsChange(e) {
      const files = e.target.files ? Array.from(e.target.files) : []
      if (this.form.attachments.length + files.length > 10) {
        toast.error('Maximum 10 attachments allowed')
        e.target.value = ''
        return
      }
      this.form.attachments.push(...files.map(f => ({ file: f, name: f.name })))
      e.target.value = ''
    },

    removeAttachment(idx) {
      this.form.attachments.splice(idx, 1)
    },

    updateProductInfo(item) {
      const p = this.products.find(x => x.id === item.productId)
      if (p) item.unit = this.getProductUnitLabel(p) || ''
    },

    getProductUnitLabel(p) {
      if (!p?.unit) return ''
      return p.unit.unit || p.unit.symbol || p.unit.name || ''
    },

    getServiceUnitLabel(s) {
      if (!s?.unit) return ''
      return s.unit.name || s.unit.symbol || ''
    },

    getItemUnit(item) {
      if (item.unit) return item.unit
      if (item.type === 'service') {
        const s = this.services.find(x => x.id === item.serviceId)
        return s ? this.getServiceUnitLabel(s) : ''
      }
      const p = this.products.find(x => x.id === item.productId)
      return p ? this.getProductUnitLabel(p) : ''
    },

    onProductQuery() {
      this.showProductList = true
      this.highlightedIndex = 0
    },

    onProjectQuery() {
      this.showProjectList = true
      this.form.project = ''
      this.errors.project = ''
    },

    scheduleCloseProjectList() {
      this.closeProjectListTimer = setTimeout(() => { this.showProjectList = false }, 150)
    },

    selectProject(project) {
      this.form.project = project.name
      this.projectQuery = project.name
      this.showProjectList = false
      this.errors.project = ''
    },

    confirmProjectSelection() {
      if (this.filteredProjects.length > 0) {
        this.selectProject(this.filteredProjects[0])
      }
    },

    selectProduct(p) {
      this.newItem.productId = p.id
      this.newItem.unit = this.getProductUnitLabel(p) || ''
      this.productQuery = p.name
      this.showProductList = false
      this.highlightedIndex = -1
    },

    highlightNext() {
      this.highlightedIndex = Math.min(this.highlightedIndex + 1, this.filteredProducts.length)
    },

    highlightPrev() {
      this.highlightedIndex = Math.max(this.highlightedIndex - 1, 0)
    },

    confirmHighlighted() {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredProducts.length) {
        this.selectProduct(this.filteredProducts[this.highlightedIndex])
      } else if (this.highlightedIndex === this.filteredProducts.length || (this.filteredProducts.length === 0 && this.productQuery.trim())) {
        this.openCreateModal()
      }
    },

    // ── Quick create product ──────────────────────────────────────────
    getSubcategoryLabel(sc) {
      if (!sc) return ''
      if (sc.category && typeof sc.category === 'string') return sc.category
      if (sc.name) return sc.name
      if (sc.subcategory?.category) return sc.subcategory.category
      if (sc.category?.category) return sc.category.category
      return ''
    },

    openCreateModal() {
      if (this.closeProductListTimer) clearTimeout(this.closeProductListTimer)
      this.newProduct = { name: this.productQuery.trim(), categoryId: '', unitId: '', subcategoryId: null, subunitId: null }
      this.showCreateModal = true
      this.showProductList = false
      this.$nextTick(() => {
        this.$refs.newProductNameInput?.focus()
      })
    },

    closeCreateModal() {
      this.showCreateModal = false
      this.newProduct = { name: '', categoryId: '', unitId: '', subcategoryId: null, subunitId: null }
    },

    async createNewProduct() {
      if (!this.newProduct.name.trim()) {
        toast.error('Product name is required')
        return
      }
      if (!this.newProduct.categoryId) {
        toast.error('Category is required')
        return
      }
      if (!this.newProduct.unitId) {
        toast.error('Unit is required')
        return
      }
      this.savingNewProduct = true
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const fd = new FormData()
        fd.append('name', this.newProduct.name.trim())
        fd.append('categoryId', this.newProduct.categoryId)
        fd.append('unitId', this.newProduct.unitId)
        if (this.newProduct.subcategoryId) fd.append('subCategoryId', String(this.newProduct.subcategoryId))
        if (this.newProduct.subunitId) fd.append('subUnitId', String(this.newProduct.subunitId))
        const res = await fetch(`${BASE_URL}/products`, {
          method: 'POST',
          headers: { Authorization: 'Bearer ' + token },
          body: fd
        })
        const data = await res.json()
        const created = data.product || data.data || data
        if (res.ok && data.status && created && created.id) {
          this.products.push(created)
          this.selectProduct(created)
          this.addItem()
          this.closeCreateModal()
          toast.success('Product created and added to list')
        } else {
          toast.error(data.message || 'Failed to create product')
        }
      } catch {
        toast.error('Failed to create product')
      } finally {
        this.savingNewProduct = false
      }
    },
    // ─────────────────────────────────────────────────────────────────

    validateForm() {
      this.errors = {}

      if (!this.form.procurementCategoryId) this.errors.procurementCategoryId = 'Category is required'
      if (!this.form.priority) this.errors.priority = 'Priority is required'
      if (!this.form.purpose) this.errors.purpose = 'Purpose is required'
      if (this.form.purpose && this.form.purpose.length < 20) this.errors.purpose = 'Purpose should have at least 20 characters'

      if (!this.departments?.length) {
        this.errors.department = 'No departments configured — cannot submit until departments exist'
      } else if (!this.form.department || !String(this.form.department).trim()) {
        this.errors.department = 'Department is required'
      }
      if (!this.projects?.length) {
        this.errors.project = 'No projects configured — cannot submit until projects exist'
      } else if (!this.form.project || !String(this.form.project).trim()) {
        this.errors.project = 'Project is required'
      }

      if (!this.form.items.length) {
        toast.error('Add at least one item')
        return false
      }

      this.form.items.forEach((i, idx) => {
        if (i.type === 'service' ? !i.serviceId : !i.productId)
          this.errors[`items.${idx}.item`] = 'Item required'
        if (!i.quantity || i.quantity <= 0)
          this.errors[`items.${idx}.quantity`] = 'Invalid quantity'
      })

      return Object.keys(this.errors).length === 0
    },

    canShowSubmitRequest() {
      const dept = this.form.department;
      const proj = this.form.project;
      const categoryId = this.form.procurementCategoryId;
      
      // Strict validation: ensure strings are non-empty after trimming and ID is truthy
      const isDeptValid = typeof dept === 'string' && dept.trim().length > 0;
      const isProjValid = typeof proj === 'string' && proj.trim().length > 0;
      const isCategoryValid = !!categoryId; // Validates that it's not '', null, undefined, or 0
      
      return isDeptValid && isProjValid && isCategoryValid;
    },

    async savePurchaseRequest() {
      if (!this.canShowSubmitRequest()) {
        toast.error('Please fill in all the required fields')
        return;
      }
      if (!this.validateForm()) return;
      this.saving = true;
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const payload = {
          title: 'Purchase Request',
          department: String(this.form.department).trim(),
          project: String(this.form.project).trim(),
          vehicleIds: Array.isArray(this.form.vehicleIds) ? this.form.vehicleIds.map(v => Number(typeof v === 'object' && v !== null ? v.id : v)).filter(Boolean) : [],
          procurementCategoryId: Number(this.form.procurementCategoryId),
          urgency: this.form.priority ? this.form.priority.toLowerCase() : undefined,
          expectedDeliveryDate: this.form.expectedDate || undefined,
          justification: this.form.purpose || undefined,
          description: this.form.description || undefined,
          items: this.form.items.map(i => ({
            productId: i.type !== 'service' && i.productId ? Number(i.productId) : undefined,
            serviceId: i.type === 'service' && i.serviceId ? Number(i.serviceId) : undefined,
            quantity: i.quantity ? Number(i.quantity) : 1,
            description: i.notes || undefined,
            productDescription: i.productDescription || undefined,
            vehicleIds: Array.isArray(i.vehicleIds) ? i.vehicleIds.map(v => Number(typeof v === 'object' && v !== null ? v.id : v)).filter(Boolean) : [],
          })),
        };
        let res;
        if (this.isEdit) {
          res = await fetch(`${BASE_URL}/purchase-requests/${this.requestId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        } else if (this.form.attachments.length > 0) {
          const fd = new FormData();
          fd.append('data', JSON.stringify(payload));
          this.form.attachments.forEach((a) => {
            if (a.file) fd.append('attachments', a.file);
          });
          res = await fetch(`${BASE_URL}/purchase-requests/with-attachments`, {
            method: 'POST',
            headers: { 'Authorization': 'Bearer ' + token },
            body: fd
          });
        } else {
          res = await fetch(`${BASE_URL}/purchase-requests`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        }
        if (res.ok) {
          toast.success('Purchase request saved');
          this.$router.push('/transaction/purchase-request');
        } else {
          const err = await res.json().catch(() => ({}));
          toast.error(err.message || 'Failed to save purchase request');
        }
      } catch {
        toast.error('Failed to save purchase request');
      } finally {
        this.saving = false;
      }
    },

    async saveDraft() {
      if (!this.validateForm()) return
      this.saving = true;
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const payload = {
          title: 'Purchase Request',
          department: String(this.form.department).trim(),
          project: String(this.form.project).trim(),
          vehicleId: this.form.vehicleId ? Number(this.form.vehicleId) : null,
          procurementCategoryId: Number(this.form.procurementCategoryId),
          urgency: this.form.priority ? this.form.priority.toLowerCase() : undefined,
          expectedDeliveryDate: this.form.expectedDate || undefined,
          justification: this.form.purpose || undefined,
          description: this.form.description || undefined,
          items: this.form.items.map(i => ({
            productId: i.type !== 'service' && i.productId ? Number(i.productId) : undefined,
            serviceId: i.type === 'service' && i.serviceId ? Number(i.serviceId) : undefined,
            quantity: i.quantity ? Number(i.quantity) : 1,
          })),
        };
        let res;
        if (this.isEdit) {
          res = await fetch(`${BASE_URL}/purchase-requests/${this.requestId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        } else {
          res = await fetch(`${BASE_URL}/purchase-requests`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        }
        if (res.ok) {
          toast.success('Draft saved');
          this.$router.push('/transaction/purchase-request');
        } else {
          toast.error('Failed to save draft');
        }
      } finally {
        this.saving = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'vue-multiselect/dist/vue-multiselect.min.css';

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;

.check-button {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-group {
  .components-button {
    display: flex;
    align-items: center;
    justify-content: left;
    span.switcher {
      position: relative;
      width: 156px;
      height: 40px;
      border-radius: 10px;
      margin-top: 4px;
      input {
        appearance: none;
        position: relative;
        width: 130px;
        height: 40px;
        border-radius: 3px;
        border-color: #d2d2d2 !important;
        background: $primary;
        outline: none;
        font-family: 'Oswald', sans-serif;
       
        &:before {
          content: 'Yes';
          left: 13px;
          font-weight: 600;
          font-size: smaller !important;
          line-height: 33px;
          color: #FFFFFF;
        }
        &:after {
          content: 'No';
          right: 13px;
          font-weight: 600;
          font-size: smaller !important;
          line-height: 33px;
          color: #FFFFFF;
        }
      }
      label {
        z-index: 1;
        position: absolute;
        width: 55px;
        height: 32px;
        margin: 0;
        top: 4px;
        left: 71px !important;
        border-radius: 3px;
      }
      &.switcher-1 {
        input {
          transition: .25s -.1s;
          &:checked {
            background: $primary;
            &:before { color: $white; transition: color .5s .2s; }
            &:after  { color: #ffffff; transition: color .5s; }
            & + label {
              left: 4px !important;
              background: $green;
              transition: left .5s, right .4s .2s;
              height: 25px !important;
              font-size: smaller !important;
            }
          }
          &:not(:checked) {
            background: $primary;
            transition: background .5s -.1s;
            &:before { color: #ffffff; transition: color .5s; }
            &:after  { color: $white;  transition: color .5s .2s; }
            & + label {
              left: 100px;
              right: 10px;
              background: $green;
              transition: left .4s .2s, right .5s, background .35s -.1s;
              height: 25px !important;
              font-size: smaller !important;
            }
          }
        }
      }
    }
  }
}

.purchase-request-action-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 30px;
  height: 30px;
  white-space: nowrap;
}

.type-toggle-active {
  background-color: #4f506e !important;
  color: white !important;
  border-color: #4f506e !important;
}

.type-toggle-active:hover {
  background-color: #3d3e58 !important;
  border-color: #3d3e58 !important;
  color: white !important;
}

.search-results { box-shadow: 0 4px 11px rgba(0,0,0,0.08); }
.search-item { cursor: pointer }
.search-item:hover { background: #f8f9fa }
.add-new-row {
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}
.add-new-row:hover {
  background: #e9ecef;
}

/* Quick-create product modal */
.qcp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.qcp-box {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.qcp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 20px;
  border-bottom: 1px solid #e9ecef;
}
.qcp-body {
  padding: 18px 20px 10px;
}
.qcp-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 11px 20px;
  border-top: 1px solid #e9ecef;
}

/* Attachment chips */
.attachment-chip {
  font-size: 11px;
  padding: 6px 8px 6px 10px;
  color: white;
}
.attachment-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: white;
}
.attachment-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  margin-left: 4px;
  font-size: 16px;
  line-height: 1;
  color: white;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s;
}
.attachment-remove:hover {
  background: rgba(255, 255, 255, 0.35);
  color: white;
}

/* Smooth fade/slide when toggling between Product and Service */
.item-type-fade-enter-active,
.item-type-fade-leave-active {
  transition: opacity 0.18s ease-out, transform 0.18s ease-out;
}
.item-type-fade-enter-from,
.item-type-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
</style>
